import L from 'leaflet';
import detail_dosha_map from './detail/detail_dosha_map';
import detail_uryo_map from './detail/detail_uryo_map';
import detail_uryo_graph_img from './detail/detail_uryo_graph_img';
import util from './util';
import detail_snake from './detail/detail_snake';
window.onload = () => {
    comMain(() => {
        setTimeout(() => {
            let detail = new uryoDetail();
            detail.Initilize();
        }, 10);
    });
};
/**
 * 雨量詳細画面（４画面表示）
 */
export default class uryoDetail {
    /**
     * コンストラクタ
     */
    constructor() {
        this._doshaMap = null;
        this._uryoMap = null;
        this._uryoGraph = null;
        this._snakeGraph = null;
        this._uryoPointTable = {};
    }
    /**
     * 初期化処理
     */
    Initilize() {
        const self = this;
        const uryoGeoJson = util.getGeoJson(util.getPath(dosya_1kmesh_env.uryoGeoJson));
        //  雨量計測地点テーブル作成
        this._uryoPointTable = this.createUryoPointTable(uryoGeoJson);
        //  地図の表示位置取得
        let mapPos = this.getMapPos();
        if (mapPos.uryo_point) {
            this._uryoGraph = new detail_uryo_graph_img(mapPos);
        }
        if (mapPos.mesh_code) {
            this._snakeGraph = new detail_snake(mapPos.mesh_code, true);
        }
        this._uryoMap = new detail_uryo_map(mapPos, (uryoPiont) => { self.onUryoPointClick(uryoPiont); }, false);
        this._doshaMap = new detail_dosha_map(mapPos, (meshcode) => { self.onMeshClick(meshcode); });
        if (mapPos.uryo_point) {
            this._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
        }
        this._doshaMap.dispMeshLayer();
        this._doshaMap.selectMesh(mapPos.mesh_code);
        //  地図の同期表示
        this.setLinkMap(this._doshaMap.Map, this._uryoMap.Map);
        //  説明のツールチップ表示
        this.setUryoMapToolTip();
        //  
        this.setUpdateCheckInterval(this._doshaMap, this._uryoMap);
    }
    /**
     * データの更新チェック処理
     */
    setUpdateCheckInterval(doshaMap, uryoMap) {
        setInterval(() => {
            //  土砂災害メッシュの更新チェック
            if (doshaMap.checkUpdateLayer()) {
                if (this._snakeGraph) {
                    //  更新があった場合、スネーク図も再描画
                    this._snakeGraph.reflash();
                }
            }
        }, config.doshaDetailDataCheckMiliSec);
        setInterval(() => {
            //  雨量分布図の更新チェック
            //  更新があった場合、雨量グラフも再描画
            if (uryoMap.checkUpdateLayer()) {
                if (this._uryoGraph) {
                    this._uryoGraph.reflash();
                }
            }
        }, config.uryoDetailDataCheckMiliSec);
    }
    /**
     * 説明用ツールチップのイベント設定
     */
    setUryoMapToolTip() {
        let mapElement = $("#detail_uryo_map");
        let tipElement = $("#detail_uryo_map_tooltip");
        mapElement.mouseenter((e) => {
            tipElement.show();
        });
        mapElement.mouseleave((e) => {
            tipElement.hide();
        });
        tipElement.click((e) => {
            tipElement.hide();
        });
    }
    /**
     * 地図の表示位置をリンクします
     * @param doshaMap
     * @param uryoMap
     */
    setLinkMap(doshaMap, uryoMap) {
        //  地図の同期表示処理実装
        let ownerMap = null;
        let setOwner = (le) => {
            if (ownerMap === null) {
                ownerMap = le.target;
            }
        };
        let moveend = (le) => {
            if (ownerMap && ownerMap === le.target) {
                let center = ownerMap.getCenter();
                if (ownerMap !== doshaMap)
                    doshaMap.panTo(center);
                if (ownerMap !== uryoMap)
                    uryoMap.panTo(center);
                ownerMap = null;
                if (this._doshaMap) {
                    this._doshaMap.reflash();
                }
            }
        };
        doshaMap.on("movestart", setOwner);
        uryoMap.on("movestart", setOwner);
        doshaMap.on("moveend", moveend);
        uryoMap.on("moveend", moveend);
    }
    /**
     * 雨量計測地点クリック時
     * @param uryoPoint 雨量計測地点コード
     */
    onUryoPointClick(uryoPoint) {
        const topCode = uryoPoint.substr(0, 1);
        if ((topCode != '0') && (topCode != '9')) {
            let mapPos = this.getMapPosUryoPointLatLng(uryoPoint);
            this.setView(mapPos);
        }
    }
    /**
     * メッシュクリック時イベント
     * @param meshcode メッシュコード
     */
    onMeshClick(meshcode) {
        let mapPos = this.getMapPosByMeshCode(meshcode);
        this.setView(mapPos);
    }
    /**
     * 地図表示位置の変更
     * @param latlng
     */
    setView(mapPos) {
        //  雨量計測地点地図
        if (this._uryoMap) {
            if (mapPos.uryo_point) {
                this._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            }
            this._uryoMap.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  土砂災害メッシュ
        if (this._doshaMap) {
            if (mapPos.mesh_code) {
                this._doshaMap.selectMesh(mapPos.mesh_code);
            }
            this._doshaMap.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  雨量グラフ
        if (this._uryoGraph && mapPos.uryo_point) {
            this._uryoGraph.dispGraph(mapPos.uryo_point);
        }
        //  スネーク図
        if (this._snakeGraph && mapPos.mesh_code) {
            this._snakeGraph.dispGraph(mapPos.mesh_code);
        }
    }
    /**
     * メッシュコードから地図表示情報の取得
     * @param meshcode
     */
    getMapPosByMeshCode(meshcode) {
        let latlng = util.meshToLatLng(meshcode);
        return {
            center: latlng,
            zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            mesh_code: meshcode,
            uryo_point: this.getNearestUryoPoint(latlng),
        };
    }
    /**
     * 雨量計測地点から、地図表示情報を取得
     * @param uryoPoint
     */
    getMapPosUryoPointLatLng(uryoPoint) {
        let latlng = this.getUryoPointLatLng(uryoPoint);
        return {
            center: latlng,
            zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            mesh_code: util.latlngToMesh(latlng),
            uryo_point: uryoPoint,
        };
    }
    /**
     *
     */
    getMapPos() {
        let mesh = util.getUrlVars('mesh'); //  引数のメッシュコード
        let uryoPoint = util.getUrlVars('ccd'); //  引数の雨量計測地点
        if (mesh) {
            return this.getMapPosByMeshCode(mesh);
        }
        else if (uryoPoint) {
            return this.getMapPosUryoPointLatLng(uryoPoint);
        }
        else {
            //  メッシュコードまたは雨量計測地点が指定されていない場合、エラーとする
            alert(dosya_1kmesh_env.message.error.noPoint);
            return {
                center: config.initMapLatLon,
                zoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
                minZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
                maxZoom: dosya_1kmesh_env.deteil_uinfo_map_zoom,
            };
        }
    }
    /**
     * 雨量計測地点テーブルの生成
     * @param geoJson
     */
    createUryoPointTable(geoJson) {
        let result = {};
        geoJson.features.forEach((f) => {
            let prop = f.properties;
            let geo = f.geometry;
            if (prop && geo) {
                if (geo.coordinates.length >= 2) {
                    let lng = geo.coordinates[0];
                    let lat = geo.coordinates[1];
                    result[prop.code] = new L.LatLng(lat, lng);
                }
            }
        });
        return result;
    }
    /**
     * 雨量ポイントの経緯度を取得
     */
    getUryoPointLatLng(uryoPoint) {
        if (this._uryoPointTable) {
            if (this._uryoPointTable[uryoPoint]) {
                return this._uryoPointTable[uryoPoint];
            }
        }
        alert(dosya_1kmesh_env.message.error.uryoNoPosition);
        return config.initMapLatLon;
    }
    /**
     * 最寄りの雨量計測地点を取得
     * @param latLng
     */
    getNearestUryoPoint(latLng) {
        let neerDistance = Number.MAX_VALUE;
        let neerPoint = '';
        for (let key in this._uryoPointTable) {
            let uryoPointLatLng = this._uryoPointTable[key];
            let distance = util.getDistance(latLng, uryoPointLatLng);
            if (neerDistance > distance) {
                neerDistance = distance;
                neerPoint = key;
            }
        }
        ;
        return neerPoint;
    }
}
